import { useStyles } from "./styles";
import { Grid, Table, TableHead, TableBody, TableRow, TableCell, Typography, CircularProgress, TablePagination } from '@material-ui/core';
import Button from '../../components/button';
import { useHistory } from 'react-router-dom';
import { TableDataStruct } from 'interfaces/Datastructures';
import { useEffect, useRef, useState } from "react";
import { axiosHelperWithToken } from "utils/axios";
import SearchIcon from '@mui/icons-material/Search';

import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "store/slices/snackbar/snackbarSlice";
import { getClientId } from "store/selectors/userSelector";
import { Divider, IconButton, InputBase, Paper } from "@mui/material";
function ExamsView() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchString, setSearchString] = useState('');
  const searchInput = useRef<any>();
  const clientId = useSelector(getClientId);
  // state for paginated table data
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const cellTitles = [
    'Exam Date',
    'Exam Type',
    'Patient Name',
    //'Exam Id'
  ];

  const keyOrder = [
    'examDate',
    'examType',
    'patient',
    //'examId'
  ];

  useEffect(() => {
    const axios = axiosHelperWithToken();
    const params = searchString === '' ? {} : { searchText: searchString }
    axios.get('/Patient/exams', { params }).then((response) => {
      setTableData(response.data);
    }).catch(() => {
      dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
    }).finally(() => {
      setIsLoading(false);
    });
  }, [searchString, dispatch]);
  const handleChangePage = (event: any, newPage: number) => setPage(newPage);

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = () => {
    setSearchString(searchInput.current?.lastChild?.value)
    setPage(0);
  };

  return (
    <Grid xs={10} className={classes.customerListViewWrapper}>
      {clientId && <Typography component="h1" variant="h3" color="inherit" gutterBottom>
        Client ID: <b>{clientId}</b>
      </Typography>}
      <Typography component="h1" variant="h5" color="inherit" gutterBottom className={classes.examsHeader}>
        Patient Exams
      </Typography>
      <Paper
        component="form"
        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400, boxShadow: 'none' }}
      >
        <InputBase type="search" id="txtSearchExams" ref={searchInput}
          sx={{ ml: 1, flex: 1, borderRadius: '20px' }}
          placeholder="Search by Name/Exam Type/Exam Date"
          inputProps={{ 'aria-label': 'Search' }}
          onChange={(ev: any) => { if (ev.target.value === '') handleSearch() }}
          onKeyPress={(ev: any) => { if (ev.key === 'Enter') { ev.preventDefault(); handleSearch() } }}
        />
        <IconButton type="button" sx={{ p: '10px' }} aria-label="search"
          onClick={(ev: any) => { ev.preventDefault(); handleSearch() }}>
          <SearchIcon />
        </IconButton>
      </Paper>
      <Table>
        {isLoading ? <div style={{ margin: '0 auto', textAlign: 'center' }}><CircularProgress disableShrink /></div> :
          <>
            <TableHead className={classes.tableHeadRow}>
              <TableRow>
                {cellTitles.map((titleText, index) => {
                  return (
                    <TableCell key={index} className={classes.tableCell}>{titleText}</TableCell>
                  );
                })}
                <TableCell className={classes.tableCell}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!isLoading && tableData.length === 0 ?
                <div>No results</div>
                : null}
              {!isLoading && tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((rowData: TableDataStruct, index: number) => {
                return (
                  <TableRow key={index} className={classes.tableRow}>
                    {keyOrder.map((key: string, index: number) => {
                      let value = rowData[key];
                      switch (key) {
                        case 'examDate':
                          value = moment(rowData[key]).format('MM/DD/YYYY');
                          break;
                        case 'patient':
                          value = `${rowData[key].firstName} ${rowData[key].lastName}`
                          break;
                        default:
                          break;
                      }
                      return (
                        <TableCell key={index} className={classes.tableCell}>{value}</TableCell>
                      );
                    })}
                    <TableCell className={classes.tableCell}>
                      <div className={classes.actionButtonsWrapper}>
                        <Button
                          text={'View'}
                          styles={{ marginRight: '15px' }}
                          action={() => {
                            history.push(`/client/${rowData['patientId']}/${rowData['examId']}`)
                          }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </>}
      </Table>
      {tableData.length > 0 && tableData.length > 5 && <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        component="div"
        count={tableData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />}
    </Grid>
  )
}

export default ExamsView
